











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaFoto} from '@/model/resource/CargaFoto'
import {CargaFotoCollection} from '@/model/collection/CargaFotoCollection'
import {ListCargaFotoSchema} from '@/schema/resource/CargaFoto/ListCargaFotoSchema'
import {CsvCargaFotoSchema} from '@/schema/resource/CargaFoto/CsvCargaFotoSchema'

@Component
export default class ListCargaFotoView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaFotoSchema()
  collection = new CargaFotoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaFoto) {
    Helper.pushByName('editCargaFoto', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaFotoCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaFoto()
    new CsvCargaFotoSchema().downloadCsv(csv.all())
  }
}
